/**
 * Gesture-gated splash timeline. Animation t and boing schedule share one arm time.
 */
import { SPLASH_BOING_IMPACT_TIMES_S } from './splashConstants';
import {
  armSplashTimelineAudio,
  isSplashAudioUnlockedRecently,
  resetSplashBoingScheduleState,
  wasSplashBoingWebAudioScheduledOnArm,
} from './splashSound';

let splashTimelineStartMs = null;

/** Start visual splash animation (no gesture required). */
export function armSplashTimeline() {
  if (splashTimelineStartMs == null) {
    splashTimelineStartMs = performance.now();
  }
}

/** @returns {boolean} true if Web Audio scheduled all impacts on this arm */
export function armSplashTimelineFromGesture() {
  armSplashTimeline();
  resetSplashBoingScheduleState();
  return armSplashTimelineAudio(SPLASH_BOING_IMPACT_TIMES_S, 0);
}

/**
 * Auto-arm at splash mount after login unlock (no new gesture).
 * @param {number} [withinMs=10000]
 * @returns {boolean}
 */
export function tryAutoArmSplashTimelineAfterLogin(withinMs = 10000) {
  if (!isSplashAudioUnlockedRecently(withinMs)) return false;
  resetSplashBoingScheduleState();
  const elapsedS = getSplashElapsedMs() / 1000;
  return armSplashTimelineAudio(SPLASH_BOING_IMPACT_TIMES_S, elapsedS);
}

export function getSplashElapsedMs() {
  return splashTimelineStartMs != null ? performance.now() - splashTimelineStartMs : 0;
}

export function isSplashTimelineArmed() {
  return splashTimelineStartMs != null;
}

export function isSplashBoingWebAudioActive() {
  return wasSplashBoingWebAudioScheduledOnArm();
}

export function resetSplashTimeline() {
  splashTimelineStartMs = null;
  resetSplashBoingScheduleState();
}
